import React, {Component} from 'react';
import { withRouter } from "react-router-dom";




class UserSetup extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>User Account Setup </h2>

                <br/>
               

                <h6> The New Account Email: </h6>
                
                <p className='text-primary'>When setting up a new account by an administrator, new users will receive the following email.
                They must change their password to log into the system.  BOUNTE will auto-assign a temporary password that nobody knows first,
                then send a password change request only to the email address on record.  </p>
                <p className='text-danger'>Remind users to check their SPAM folders for this email just in case. If they do not recieve the email, BOUNTE support can resend. This login is also needed prior to logging into the Mobile and Venue web site </p>

                <br/><br/><br/>
                <div className="text-center">
                <img className='text-center' style={{width:"50%", height:"50%"}} src='./images/accountsetup.png'  alt=''/> 
              
                   
                </div>

                <br/>

                <h6> The Welcome Email: </h6>


                <p className='text-primary'>After receiving the password reset email, the next email will be to verify their email.</p>
                <div className="text-center">
                    <img className='text-center' style={{width:"50%", height:"50%"}} src='./images/welcomeemail.png' alt=''/> 
                </div>


                 <br/> 
              


                <br/>

                 
                
            </div>
        )
       


    }

}
export default withRouter(UserSetup);
